import { definitions } from "@/services/metruyenvl";
import { Constants } from "@/types/constants";
import { Popover, Skeleton } from "antd";
import Image from "next/image";
import React from "react";

function CoverImageDetail({ book }: { book?: definitions["do.BookDO"] }) {
    return (
        <Popover content={book?.name as string} placement="top">
            {book?.thumbnail ? (
                <div className="book-cover">
                    <div className="book-inside hidden md:block"></div>
                    <div className="book-image overflow-hidden lg:h-72 md:h-44 md:w-32 lg:w-60 h-48 w-40 m-auto">
                        <Image unoptimized={true} quality={100} priority src={book?.thumbnail ?? Constants.DefaultBookThumbnail} alt={book?.name ?? ""} width={100} height={100} className="rounded w-1/2 m-auto md:m-0" />
                        <div className="light"></div>
                    </div>
                </div>
            ) : (
                <Skeleton active paragraph={{ rows: 9 }} className="lg:h-72 md:h-44 md:w-32 lg:w-60 h-48 w-40 m-auto" />
            )}
        </Popover>
    );
}

export default CoverImageDetail;
